import { render, staticRenderFns } from "./ChannelLanguages.vue?vue&type=template&id=295e7af9"
import script from "./ChannelLanguages.vue?vue&type=script&lang=js"
export * from "./ChannelLanguages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports